import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NotificationConnectionService} from '../../lib/services/notifications/notification-connection.service';
import {Router} from '@angular/router';
import {command} from '../../layout/sidebar/menu';
import {UserUtilsService} from '../../lib/services/user/user-utils.service';
import * as pubsub from "pubsub-js"
import {TranslateService} from '@ngx-translate/core';
import {firstValueFrom} from 'rxjs';
import {TextUtils} from "../../lib/services/utils/text-utils.service";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, AfterViewInit {
    @Input() currentLang: string = "";
    @Input() notificationType: string = "";
    @Output() setNotificationRead: EventEmitter<any> = new EventEmitter();
    @Output() deleteNotification: EventEmitter<any> = new EventEmitter();
    @Output() updateAllNotifications: EventEmitter<any> = new EventEmitter();
    @Output() openModalPendingPaymentsToAuthEvent: EventEmitter<any> = new EventEmitter();
    @Input()
    set isOpenNotificationDialog(value: boolean){
        if (!value){
        this.showNotificationBanner()
        }
    }


    showNotificationDialog: boolean = false;
    activeButton: number = 1;
    template: string = "";
    translations: any;
    activePoint: boolean
    constructor(
        public notificationConnectionService: NotificationConnectionService,
        private utilsService: UserUtilsService,
        private router: Router,
        private translate: TranslateService,
        public textUtils: TextUtils,
        private cdr: ChangeDetectorRef
    ) {

    }

    async ngOnInit(): Promise<void> {
        await this.setTranslations()
        pubsub.subscribe("changeLanguage", async (msg: any, data: any) => {
            await this.setTranslations()
        })
        const notificationsSeen = sessionStorage.getItem('notificationSeen');
        if (notificationsSeen == null){
            sessionStorage.setItem('notificationSeen','true')
        }
        this.notificationConnectionService.validateNotifications()
        this.notificationConnectionService.activePoint.subscribe((data)=>{
            this.activePoint = data;
            this.cdr.detectChanges()
        })
    }

    async setTranslations() {
        this.translations = await firstValueFrom(this.translate.get([
            'NOTIFICATIONS'
        ]))
    }

    setReadNotification(idNotification: number) {
        this.setNotificationRead.emit(idNotification)
    }

    showNotificationBanner() {
        this.showNotificationDialog = !this.showNotificationDialog
        sessionStorage.setItem('notificationSeen','true')
        this.notificationConnectionService.activePoint.next(false)
        this.notificationConnectionService.showNotificationContentDialog = this.showNotificationDialog
    }

    setNotifications(event: Event, activeNumber: number) {
        event.preventDefault()
        this.activeButton = activeNumber
    }

    buildLink() {
        window.open(environment.bancaDigitalPage,'_blank')
        command(0)
    }

    async deleteNotifications(notificationId: number) {
        this.deleteNotification.emit(notificationId);
    }

    async selectAll(action: String) {
        this.updateAllNotifications.emit(action);
    }

    openModalPendingPaymentsToAuth(contenido: any, notificationId:any, tipoNotificacion:any) {
        this.openModalPendingPaymentsToAuthEvent.emit({contenido, notificationId, tipoNotificacion})
    }
    ngAfterViewInit() {
        this.notificationConnectionService.validateNotifications()
    }
}
